import React from 'react';

export default function PageLoader({ label = 'Loading…' }) {
  return (
    <div className="w-full min-h-[40vh] flex items-center justify-center">
      <div className="text-sm text-muted-foreground">{label}</div>
    </div>
  );
}
